/* NOMI v20.27: About page scroll story.
   1. Hero cutouts drift at their own speed (front faster, back slower) with a slight rotation.
   2. Gallery pins while its track slides sideways; a bar shows progress. Phones swipe instead.
   3. Founder note lights up word by word as the block moves through the viewport.
   Nothing here blocks content, and reduced-motion visitors get static layout. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var header = document.querySelector('.nomi-nav-header');
  function headerH() { return header ? header.getBoundingClientRect().height : 0; }
  function setHeaderVar() { document.documentElement.style.setProperty('--nb-header', headerH() + 'px'); }
  setHeaderVar(); window.addEventListener('resize', setHeaderVar);

  /* 1. hero floats */
  var hero = document.querySelector('[data-na-hero]');
  var floats = hero ? Array.prototype.slice.call(hero.querySelectorAll('.na-float')) : [];
  floats.forEach(function (f, i) {
    f._speed = parseFloat(f.getAttribute('data-speed') || (0.12 + (i % 3) * 0.1));
    f._rot = parseFloat(f.getAttribute('data-rot') || ((i % 2 ? 1 : -1) * (6 + i * 2)));
  });

  /* 2. gallery */
  var gallery = document.querySelector('[data-na-gallery]');
  var track = gallery && gallery.querySelector('.na-track');
  var bar = gallery && gallery.querySelector('.na-progress i');
  var sticky = gallery && gallery.querySelector('.na-gallery-sticky');
  var mobile = window.matchMedia('(max-width: 820px)');
  function sizeGallery() {
    if (!gallery || !track) return;
    if (mobile.matches || getComputedStyle(track).display === 'grid') { gallery.style.height = ''; track.style.transform = ''; gallery._travel = 0; return; }
    var travel = track.scrollWidth - window.innerWidth + parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nb-edge') || 40);
    gallery._travel = Math.max(0, travel);
    gallery.style.height = (sticky.offsetHeight + gallery._travel) + 'px';
  }

  /* 3. words */
  var words = document.querySelector('[data-na-words]');
  var spans = [];
  if (words) {
    var text = words.querySelector('.na-words-text');
    var raw = text.textContent.trim().split(/\s+/);
    text.textContent = '';
    raw.forEach(function (w, i) { var s = document.createElement('span'); s.textContent = w; text.appendChild(s); if (i < raw.length - 1) text.appendChild(document.createTextNode(' ')); spans.push(s); });
  }

  var ticking = false;
  function frame() {
    ticking = false;
    var y = window.scrollY, vh = window.innerHeight;
    if (hero && !reduce) {
      var hr = hero.getBoundingClientRect();
      if (hr.bottom > 0) {
        floats.forEach(function (f) {
          var d = y * f._speed;
          f.style.transform = 'translate3d(0,' + (-d) + 'px,0) rotate(' + (f._rot + d * 0.02) + 'deg)';
        });
      }
    }
    if (gallery && track && !mobile.matches && gallery._travel) {
      var gr = gallery.getBoundingClientRect(), hh = headerH();
      var p = Math.min(1, Math.max(0, (hh - gr.top) / gallery._travel));
      track.style.transform = reduce ? '' : 'translate3d(' + (-p * gallery._travel) + 'px,0,0)';
      if (bar) bar.style.width = (p * 100) + '%';
    }
    if (spans.length && !reduce) {
      var wr = words.getBoundingClientRect();
      var start = vh * 0.85, end = vh * 0.25;
      var pr = (start - wr.top) / (wr.height + start - end);
      pr = Math.min(1, Math.max(0, pr));
      var lit = Math.round(pr * spans.length);
      spans.forEach(function (s, i) { s.classList.toggle('is-lit', i < lit); });
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { sizeGallery(); onScroll(); });
  mobile.addEventListener('change', function () { sizeGallery(); onScroll(); });
  window.addEventListener('load', function () { sizeGallery(); onScroll(); });
  sizeGallery(); frame();
  if (reduce && spans.length) spans.forEach(function (s) { s.classList.add('is-lit'); });
})();
